var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 39,
    viewBox: "0 0 29 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.89v25.6c0 3.535 2.866 6.4 6.4 6.4h14.4c3.534 0 6.4-2.865 6.4-6.4V8.09H3.047C1.365 8.09 0 6.727 0 5.045 0 3.79.88 2.708 2.107 2.452L24 .09v8",
    transform: "translate(-143 -1552) translate(144 1553)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8 20.49c0 2.431-1.97 4.4-4.4 4.4-2.43 0-4.4-1.969-4.4-4.4 0-2.43 1.97-4.4 4.4-4.4 2.43 0 4.4 1.97 4.4 4.4zM15.511 23.602L20.8 28.891",
    transform: "translate(-143 -1552) translate(144 1553)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.9e2e120340d1517387c48b7d8342f5c2.svg";
export { ForwardRef as ReactComponent };